import React, { useEffect, useState } from 'react';
import Marquee from 'react-fast-marquee';
import api from '../api';



export default function AnnouncementBar() {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    api.get(`/api/announcements`).then(r => setAnnouncements(r.data)).catch(() => {});
  }, []);

  if (announcements.length === 0) return null;

  return (
    <div data-testid="announcement-bar" className="bg-neonBlue/5 border-b border-neonBlue/10 py-2.5 overflow-hidden">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {announcements.map((a, i) => (
          <span key={i} className="mx-8 text-sm font-medium text-neonBlue/80 tracking-wider uppercase">
            <span className="text-neonGold mr-2">&#9733;</span>
            {a.text}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
